export const StoryStats = (props: { playerCount: number; roundCount: number }) => {
    const { playerCount, roundCount } = props;

    return (
        <div className="d-flex text-dark gap-3 align-items-center fw-bold">
            <div className="text-nowrap" title={playerCount + playerCount === 1 ? " player" : " players"}>
                <small>🧑 {playerCount}</small>
            </div>

            <div className="text-nowrap" title={roundCount + roundCount === 1 ? " round" : " rounds"}>
                <small>🔔 {roundCount}</small>
            </div>
        </div>
    );
};
